import Norecords from "../components/customHelpers/Norecords";
import Loading from "../components/customHelpers/Loading";

import { TableBody, TableRow, TableCell, makeStyles } from "@material-ui/core";

import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import useTable from "../components/customHelpers/useTable";
import Notify from "../components/customHelpers/Notify";
import Notification from "../components/customHelpers/Notification";
import Staff from "../actions/staff";
const headCells = [
  { id: "activity", label: "Activity" },
  { id: "date", label: "Date" },
];
const useStyles = makeStyles((theme) => ({
  image: {
    borderRadius: "55%",
    height: "45px",
    width: "45px",
  },
}));
const ActivityLog = ({ id }) => {
  const classes = useStyles();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewActivityLog } = Staff();
  const [activity, setActivity] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    if (id) {
      getAllActivity(id);
    }
  }, []);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getAllActivity = (Id) => {
    console.log(id);
    setValues({ ...values, loading: true });
    viewActivityLog(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.activity) {
        setValues({
          ...values,
          loading: false,
        });
        setActivity(data.activity);
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(activity, headCells, filterFn);
  return (
    <div className="card">
      <Grid container>
        <Grid item xs={12} className="card__body">
          {loading ? (
            <Loading />
          ) : (
            <>
              {" "}
              <TblContainer>
                <TblHead />
                <TableBody>
                  {recordsAfterPagingAndSorting().length > 0 ? (
                    recordsAfterPagingAndSorting().map((item) => (
                      <TableRow key={item.Id}>
                        <TableCell>{item.activity}</TableCell>
                        <TableCell>
                          {new Date(item.createdAt).toLocaleString()}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <Norecords col={6} />
                  )}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </>
          )}
        </Grid>
      </Grid>

      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
};

export default ActivityLog;
